import {useState} from 'react'
import {getUserByProfile} from '../services'
import {SelectModel} from '../model'
import {mapDataSelect} from '../../../util/functions'
const useUserByProfile = () => {
  const [loading, setLoading] = useState(false)
  const [userByProfile, setUserByProfileList] = useState<SelectModel[]>([])

  const getUserByProfileAPI = async (text: string) => {
    return await getUserByProfile(text)
  }

  const getUserByProfileData = async (text: string) => {
    setLoading(true)
    try {
      const response = await getUserByProfileAPI(text)
      return response.data.data
    } catch (error) {
      console.error('Error fetching service data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updateUserByProfileList = (mappedSites: {value: string; label: string}[]) => {
    setUserByProfileList(mappedSites)
  }
  const getUserByProfileMappedData = async (text: string) => {
    try {
      const data = await getUserByProfileData(text)
      const mappedSites = mapDataSelect(data)
      return mappedSites
    } catch (error) {
      console.error('Error fetching service data:', error)
    }
  }
  const getUserByProfileList = async (text: string) => {
    try {
      const data = await getUserByProfileData(text)
      const mappedSites = mapDataSelect(data)
      updateUserByProfileList(mappedSites)
    } catch (error) {
      console.error('Error fetching service data:', error)
    }
  }

  const handleClear = () => {
    setUserByProfileList([])
  }

  return {
    loading,
    userByProfile,
    getUserByProfileList,
    handleClear,
    getUserByProfileMappedData,
    getUserByProfileData,
  }
}

export default useUserByProfile
